module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-layer-options-widget\">\n	<div class=\"table wh100 table-0-100\">\n		<div>\n			<div>\n				<div class=\"split\">\n					<div class=\"split__right\">\n						<div class=\"icon-12 icon-close gl-pointer\" on-click=\"onCloseClick\"></div>\n					</div>\n				</div>\n			</div>\n		</div>\n		<div>\n			<div>\n				<div class=\"cell__abs_container\">\n					<div class=\"cell__abs\">\n						<div class=\"table wh100 table-0-100\">\n							<div>\n								<div>\n									<div>\n										<control type=\"data-autocomplete\" target=\"layer.sourceOptions.typename\" bind=\"layer.sourceOptions.typeid:id\" source=\"Glonass.Data.ObjectTypes\" column=\"name\" html-placeholder=\"Тип объекта\" strict=\"yes\" on-select=\"onObjectTypeSelect\" />\n									</div>\n									<div>\n										<control type=\"text\" target=\"layer.sourceOptions.name\" html-placeholder=\"Название\" on-live-change=\"onNameChange\" />\n									</div>\n								</div>\n							</div>\n							<div>\n								<div>\n									<div class=\"cell__abs_container\">\n										<div class=\"cell__abs overflow-y__auto\">\n											<div class=\"table w100 table-stripped\" name=\"list-items\"></div>\n										</div>\n									</div>\n								</div>\n							</div>\n						</div>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>")
  }
  return __output.join("");

}